import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import "./lingostory.css";

function New(params) {
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const axiosOptions = {
      url: process.env.REACT_APP_API_URL + "v1/guest/list-book",
      method: "get",
      headers: {
        Accept: "application/json",
        // Authorization: `Bearer ${token}`,
      },
    };

    axios(axiosOptions)
      .then((response) => {
        // console.log(response.data.data);
        setData(response.data.data);
        setLoader(false);
      })
      .catch((err) => {
        // console.log(err.response.data.message);
        setLoader(false);
        if (err.response.status === 404) {
          setErrorMessage(err.response.data.message);
        }
      });
  }, []);

  const handleDragStart = (e) => e.preventDefault();
  const images = data.map((img) => {
    // const img = props.images
    return (
      <div className="item" key={img.id}>
        <Link to={`/book-detail/${img.book_code}`}>
          <img
            src={img.image_path}
            onDragStart={handleDragStart}
            role="presentation"
          />
        </Link>
      </div>
    );
  });

  // console.log(images)
  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  };

  const Carousel = () => (
    <AliceCarousel
      mouseTracking
      items={images}
      responsive={responsive}
      controlsStrategy="alternate"
    />
  );

  return (
    <div className="py-10 py-lg-20 bg-white">
      <div className="container" style={{ marginTop: "70px" }}>
        <div className="d-flex justify-content-center">
          <div
            className={loader === true ? "spinner-border" : ""}
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <div className="text-center mb-12">
          <h3
            className="fs-4hx fw-bolder text-dark mb-5"
            id="team"
            data-kt-scroll-offset="{default: 100, lg: 150}"
          >
            Welcome
          </h3>

          <div className="fs-5 text-muted fw-bold">
            {/* It’s no doubt that when a development takes longer to complete,
            additional costs to */}
            <br />
            {/* integrate and test each extra feature creeps up and haunts most of
            us. */}
          </div>
        </div>
        <div>
          {/* <Carousel /> */}
          <div className="row">
            {data.map((img, index) => (
              <div
                className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 mt-8"
                key={index}
              >
                <Link to={`/book-detail/${img.book_code}`}>
                  <img
                    src={img.image_path}
                    onDragStart={handleDragStart}
                    role="presentation"
                    className="img-fluid"
                    // style={{ maxWidth: "320px", maxHeight: "490px" }}
                  />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/*end::Container*/}
    </div>
  );
}

export default New;
